import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalError',
  props: {
    isVisible: { type: Boolean },
    message: {},
    titulo: {}
  },
  emits: ["update:isVisible"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const internalIsVisible = ref(props.isVisible);

watch(
  () => props.isVisible,
  (newVal) => {
    internalIsVisible.value = newVal;
  }
);

const emit = __emit;

const close = () => {
  emit("update:isVisible", false);
  internalIsVisible.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: internalIsVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalIsVisible).value = $event)),
    "max-width": "400"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                color: "red",
                icon: "mdi-dice-1"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.titulo || "Error") + " ", 1),
              _createVNode(_component_v_icon, {
                color: "red",
                icon: "mdi-dice-1"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider, { class: "my-3" }),
          _createVNode(_component_v_card_text, { class: "text-center" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.message), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "tonal",
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createTextVNode("OK")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})